module.exports = "/fonts/vendor/vue-img-inputer/dist/iconfont.svg?a5b5d4166c094c433226b2d93077cab6";